'use client'

import { IFRAME_SEARCH_PARAM_KEYS } from '@/constants/iframe'
import { queryParametersSchema } from '@/schemas/room'
import { useParams, useSearchParams } from 'next/navigation'

export const useDisableScrollLock = () => {
  const { roomId } = useParams()
  const searchParams = useSearchParams()

  const noScrolllockParam = searchParams?.get(IFRAME_SEARCH_PARAM_KEYS.NO_SCROLLLOCK)
  const parseResult = queryParametersSchema.safeParse({ noScrolllock: noScrolllockParam })
  const disableScrollLock = Boolean(roomId && parseResult.success && parseResult.data.noScrolllock)
  return disableScrollLock
}
